import React from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";

import Image from '../../../../containers/assets/career-pathway-intro.png';

const CareerPathwayIntro = () => (
  <OneVisualLayout
    section="CAREER PATHWAY"
    title="Developing Your Career Path"
    paragraph1={(
      <Fragment>
        This section provides information about disciplines that you have explored in the game
        and how you can further learn about the strategies to develop your interest and skills.
        In each round we will focus on one field of business and introduce the courses in your
        program that will support you to dive deeper in this area of knowledge.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default CareerPathwayIntro;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/career-pathway/intro.js